// extracted by css-extract-rspack-plugin
export default {"partialPaymentBanner":"partialPaymentBanner-swKYyM"};